import { callGetApiToServer } from '../callApi';

export async function listAllDropDownLanguage(authtoken) {
  try {
    let header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "authorization": "Berear " + authtoken
    }

    let endUrl = "v1/languages";

    let responseData = await callGetApiToServer(header, "GET", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
